// extracted by mini-css-extract-plugin
module.exports = {"emailSideTab":"az_jbb","expanded":"az_kbb","disappear":"az_lbb"};